(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Ganze Tabellenzeile klickbar machen (nicht nur den Titel)
  document.addEventListener('click', (event) => {
    // Nur Linksklicks berücksichtigen
    if (event.button !== 0) return;

    const row = event.target.closest('.rb-collection-table__row');
    if (!row || row.classList.contains('rb-collection-table__row--header')) return;

    // Klicks auf andere interaktive Elemente (Buttons etc.) nicht überschreiben
    const interactive = event.target.closest('button');
    if (interactive) return;

    const link = row.querySelector('.rb-collection-table__cell--name a');
    if (link) {
      event.preventDefault();
      window.location.href = link.href;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  // Ganze Tabellenzeile klickbar machen (nicht nur den Titel)
  document.addEventListener('click', (event) => {
    if (event.button !== 0) return;

    const row = event.target.closest('.rb-collection-table__row');
    if (!row || row.classList.contains('rb-collection-table__row--header')) return;

    const interactive = event.target.closest('button');
    if (interactive) return;

    const link = row.querySelector('.rb-collection-table__cell--name a');
    if (link) {
      event.preventDefault();
      window.location.href = link.href;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
